import { BackendPaymentInformation } from '../../payment-wallet';

export class ConnectPaymentMethod {
  static readonly type = '[SubscriptionPayment] Connect payment method';
  constructor(public connectPaymentData: BackendPaymentInformation, public mode: 'default' | 'deletion' = 'default') {}
}

export class DeleteConnectedPaymentMethod {
  static readonly type = '[SubscriptionPayment] Delete connected payment method';
}
